import { SendAndTrackShipment } from "./SendAndTrackShipment";
import { ShipmentInstructionsStepId, ShipmentInstructionsStepType } from "../ShipmentInstructionsStep.types";
import { shipmentInstructionStepLabels } from "../shipmentInstructionStepLabels";

export const sendAndTrackShipmentStep: ShipmentInstructionsStepType = {
  id: ShipmentInstructionsStepId.SEND_AND_TRACK_SHIPMENT,
  title: shipmentInstructionStepLabels.sendAndTrackShipment,
  component: SendAndTrackShipment,
};
